import { Link } from "react-router-dom";
import VerdictBadge from "@/components/base/VerdictBadge";
import CredibilityMeter from "@/components/base/CredibilityMeter";
import { formatHeat } from "@/utils/verdict";
import { gossipList } from "@/mocks/gossip";
import { brand, stats } from "@/mocks/site";

export default function Hero() {
  const ranking = [...gossipList].sort((a, b) => b.credibility - a.credibility).slice(0, 4);

  return (
    <section className="relative overflow-hidden border-b border-background-200 bg-background-100 paper-texture">
      <div className="absolute -top-24 -right-16 w-72 h-72 rounded-full bg-accent-200/40 blur-3xl" aria-hidden="true"></div>
      <div className="absolute bottom-0 left-1/4 w-56 h-56 rounded-full bg-primary-200/30 blur-3xl" aria-hidden="true"></div>

      <div className="relative max-w-shell mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
          <div className="lg:col-span-7 animate-rise">
            <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-secondary-300 bg-secondary-50 text-secondary-800 text-xs">
              <i className="ri-flashlight-line"></i>
              第 2026-W37 期鉴定已完成 · 新增 6 条结论
            </p>

            <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.2] tracking-tight">
              {brand.name}
              <span className="block mt-2 text-foreground-800">把每一条瓜，拆成能核对的证据</span>
            </h1>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
              {brand.description} 我们从来源等级、证据链完整度、交叉印证和官方回应四个方向拆解传闻，
              给出 0-100 的可信度分数，让你在评论区之外多一个判断依据。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <Link
                to="/gossip"
                className="px-6 py-3 rounded-control bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors text-center whitespace-nowrap"
              >
                进入爆料库
              </Link>
              <Link
                to="/about#method"
                className="px-6 py-3 rounded-control border border-background-300 bg-background-50 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors text-center whitespace-nowrap"
              >
                了解鉴定方法
              </Link>
            </div>

            <dl className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-6 border-t border-background-300 pt-6">
              {stats.map((s) => (
                <div key={s.label}>
                  <dt className="font-mono-num text-xl md:text-2xl font-bold text-foreground-950">
                    {s.value}
                  </dt>
                  <dd className="mt-1 text-xs text-foreground-500 leading-relaxed">{s.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-5 w-full animate-rise">
            <div className="border border-background-300 rounded-card bg-background-50 overflow-hidden">
              <div className="flex items-center justify-between px-5 py-4 border-b border-background-200 bg-background-100">
                <h2 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2">
                  <i className="ri-bar-chart-2-line text-primary-500"></i>
                  本周可信度榜
                </h2>
                <span className="font-mono-num text-[11px] text-foreground-400">2026-09-10 更新</span>
              </div>

              <ul className="divide-y divide-background-200">
                {ranking.map((item, index) => (
                  <li key={item.id}>
                    <Link
                      to={`/gossip/${item.id}`}
                      className="block px-5 py-4 group hover:bg-background-100 transition-colors"
                    >
                      <div className="flex items-start gap-3">
                        <span
                          className={`shrink-0 w-6 h-6 flex items-center justify-center rounded-control font-mono-num text-xs font-bold ${
                            index === 0
                              ? "bg-accent-500 text-secondary-950"
                              : "bg-background-200 text-foreground-700"
                          }`}
                        >
                          {index + 1}
                        </span>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                            {item.title}
                          </p>
                          <div className="mt-2 flex items-center gap-3">
                            <VerdictBadge verdict={item.verdict} size="sm" showIcon={false} />
                            <span className="text-[11px] text-foreground-400 flex items-center gap-1">
                              <i className="ri-fire-line"></i>
                              {formatHeat(item.heat)}
                            </span>
                          </div>
                          <div className="mt-2.5 w-32">
                            <CredibilityMeter
                              score={item.credibility}
                              verdict={item.verdict}
                              size="sm"
                            />
                          </div>
                        </div>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>

              <div className="px-5 py-4 border-t border-background-200 bg-background-100">
                <Link
                  to="/gossip"
                  className="flex items-center justify-between text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
                >
                  查看完整榜单
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}